// extracted by mini-css-extract-plugin
module.exports = {"tab_container":"TabContainer_tab_container__U54O2","tab_selector":"TabContainer_tab_selector__3n8FS","selected_tab":"TabContainer_selected_tab__1XY-W"};